export interface SessionSlice {
  documentNames: string[];
  setDocuments: (documentNames: string[]) => void;
  ownerName: string;
  setOwnerName: (ownerName: string) => void;
  passcode: string;
  setPasscode: (passcode: string) => void;
  hasPasscode: boolean;
  setHasPasscode: (hasPasscode: boolean) => void;
  preventSendingCopyToClient: boolean;
  setPreventSendingCopyToClient: (preventSendingCopyToClient: boolean) => void;
  logoUrl: string;
  setLogoUrl: (logoUrl: string) => void;
  direction: 'rtl' | 'ltr';
  setDirection: (dir: 'rtl' | 'ltr') => void;
  docIndex: number;
  incDocIndex: () => void;
  doc?: Uint8Array;
  setDoc: (newDoc: Uint8Array) => void;
}

type Set = (partial: Partial<SessionSlice> | ((state: SessionSlice) => Partial<SessionSlice>)) => void;

export const createSessionSlice = (set: Set): SessionSlice => ({
  documentNames: [],
  setDocuments: documentNames => set({ documentNames, docIndex: 0 }),
  ownerName: '',
  setOwnerName: ownerName => set({ ownerName }),
  passcode: '',
  setPasscode: passcode => set({ passcode }),
  hasPasscode: false,
  setHasPasscode: hasPasscode => set({ hasPasscode }),
  preventSendingCopyToClient: false,
  setPreventSendingCopyToClient: preventSendingCopyToClient => set({ preventSendingCopyToClient }),
  logoUrl: '',
  setLogoUrl: logoUrl => set({ logoUrl }),
  direction: 'ltr',
  setDirection: direction => set({ direction }),
  docIndex: 0,
  incDocIndex: () => set(state => ({ docIndex: state.docIndex + 1 })),
  doc: undefined,
  setDoc: doc => set({ doc }),
});
